import gql from 'graphql-tag';
import { TOOL_TYPE } from './ToolType.gql';

export const EDIT_TOOL = gql`
  ${TOOL_TYPE}
  mutation editTool(
    $commitment: [Int]
    $description: String
    $formsection: [Int]
    $id: ID!
    $organization: [Int]
    $public: Boolean
    $status: Boolean
    $team: [Int]
    $textsection: [Int]
    $thumbnailImage: String
    $title: String
    $uiFlow: String
    $vertical: [Int]
  ) {
    updateTool(
      commitment: $commitment
      description: $description
      formsection: $formsection
      id: $id
      organization: $organization
      public: $public
      status: $status
      team: $team
      textsection: $textsection
      thumbnailImage: $thumbnailImage
      title: $title
      uiFlow: $uiFlow
      vertical: $vertical
    ) {
      tool {
        ...ToolType
      }
    }
  }
`;
